/* Casual Remarks global behaviour. Loaded from theme.liquid alongside
   cr-global.css.

   Card images are requested at roughly their layout width, which is correct
   until you hover: the grid zooms the artwork 2.15x, so a 640px source is
   being blown up past 1300 device pixels and the print goes visibly grainy on
   exactly the thing the customer is trying to read.

   Rather than drop the zoom, upgrade the source on first hover. Shopify's CDN
   resizes on demand through the width parameter, so this is one extra request
   for the one card the customer is actually looking at, and nothing at all on
   page load. Each image is upgraded once. */
(function () {
  var ZOOM_WIDTH = 1400;
  var SELECTOR = '.cr-card__frame img, .card-gallery img, .product-media img, .resource-card__media img';

  function upgrade(img) {
    if (!img || img.dataset.crSharp) return;
    var src = img.currentSrc || img.src || '';
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return;

    var current = /[?&]width=(\d+)/.exec(src);
    if (current && parseInt(current[1], 10) >= ZOOM_WIDTH) {
      img.dataset.crSharp = '1';
      return;
    }
    img.dataset.crSharp = '1';

    var big = current
      ? src.replace(/([?&]width=)\d+/, '$1' + ZOOM_WIDTH)
      : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + ZOOM_WIDTH;

    // Preload before swapping so the card never flashes an empty frame.
    var pre = new Image();
    pre.onload = function () {
      img.removeAttribute('srcset');   // srcset would override the new src
      img.removeAttribute('sizes');
      img.src = big;
    };
    pre.src = big;
  }

  function onEnter(e) {
    var card = e.target.closest
      ? e.target.closest('.cr-card, .product-grid__card, .resource-card, .crp__card')
      : null;
    if (!card) return;
    card.querySelectorAll('img').forEach(upgrade);
  }

  document.addEventListener('pointerenter', onEnter, true);

  // Touch devices never hover, but they do tap. Upgrade on first touch so a
  // pinch-zoom on a phone does not show the same grain.
  document.addEventListener('touchstart', onEnter, { capture: true, passive: true });

  // Belt and braces: anything already zoomed by CSS on load.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.matches(':hover')) upgrade(img);
    });
  });
})();

/* ── Menu drawer: a close target you cannot miss ───────────────────────────
   The drawer slides in from the left and leaves a large empty column on its
   right, beside the nav links. A 44px X in the corner is technically an exit
   and practically a hunt, so that dead space becomes the close control: a big
   left-pointing arrow that reads as "push this back where it came from".

   Injected rather than templated so no theme file has to be edited, and it
   defers to the theme's own close button for the actual close, which keeps
   focus handling and history behaviour intact. */
(function () {
  var ARROW = '<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">' +
    '<path d="M30 10 L14 24 L30 38" fill="none" stroke="currentColor" ' +
    'stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function attach(drawer) {
    if (!drawer || drawer.querySelector('.cr-drawer-dismiss')) return;
    var real = drawer.querySelector('.menu-drawer__close-button');
    if (!real) return;

    var zone = document.createElement('button');
    zone.type = 'button';
    zone.className = 'cr-drawer-dismiss';
    zone.setAttribute('aria-label', 'Close menu');
    zone.innerHTML = ARROW + '<span>Close</span>';
    zone.addEventListener('click', function (e) {
      e.preventDefault();
      real.click();
    });
    drawer.appendChild(zone);
  }

  function scan() {
    document.querySelectorAll('.menu-drawer').forEach(attach);
  }

  document.addEventListener('DOMContentLoaded', scan);
  scan();
  // the drawer is rendered inside a <details>, so it appears on toggle
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'],
  });
})();
